export default __webpack_public_path__ + "static/media/jasmine.4bc9dc7c.png";